import {
  SET_ACTIVE_MOBILE_TAB,
  SET_CALIBRATION_TRIGGERED,
  SET_IS_HORIZONTAL, SET_IS_HORIZONTAL_OPENED_FILES,
  SET_IS_INTERLOCUTOR_HORIZONTAL, SET_IS_IPHONE_LOADER,
  SET_IS_MOBILE_TOOLBAR_SQUEEZED,
} from '@/shared/constants/mutationTypes';

const state = {
  isMobileToolbarSqueezed: false,
  activeMobileTab: null,
  calibrationTriggered: false,
  isHorizontal: false,
  isInterlocutorHorizontal: false,
  isHorizontalOpenedFiles: false,
  isIphoneLoader: false,
};

const getters = {
  isMobileToolbarSqueezed: state => state.isMobileToolbarSqueezed,
  activeMobileTab: state => state.activeMobileTab,
  calibrationTriggered: state => state.calibrationTriggered,
  isHorizontal: state => state.isHorizontal,
  isInterlocutorHorizontal: state => state.isInterlocutorHorizontal,
  isHorizontalOpenedFiles: state => state.isHorizontalOpenedFiles,
  isIphoneLoader: state => state.isIphoneLoader,
};

const actions = {
  setIsMobileToolbarSqueezed({ commit }, data) {
    commit(SET_IS_MOBILE_TOOLBAR_SQUEEZED, data);
  },
  setActiveMobileTab({ commit }, data) {
    commit(SET_ACTIVE_MOBILE_TAB, data);
  },
  setCalibrationTriggered({ commit }, data) {
    commit(SET_CALIBRATION_TRIGGERED, data);
  },
  setIsHorizontal({ commit }, data) {
    commit(SET_IS_HORIZONTAL, data);
  },
  setIsInterlocutorHorizontal({ commit }, data) {
    commit(SET_IS_INTERLOCUTOR_HORIZONTAL, data);
  },
  setIsHorizontalOpenedFiles({ commit }, data) {
    commit(SET_IS_HORIZONTAL_OPENED_FILES, data);
  },
  setIsIphoneLoader({ commit }, data) {
    commit(SET_IS_IPHONE_LOADER, data);
  },
};

const mutations = {
  [SET_IS_MOBILE_TOOLBAR_SQUEEZED](state, data) {
    state.isMobileToolbarSqueezed = data;
  },
  [SET_ACTIVE_MOBILE_TAB](state, data) {
    state.activeMobileTab = data;
  },
  [SET_CALIBRATION_TRIGGERED](state, data) {
    state.calibrationTriggered = data;
  },
  [SET_IS_HORIZONTAL](state, data) {
    console.log('state is horizontal: ', data);
    state.isHorizontal = data;
  },
  [SET_IS_INTERLOCUTOR_HORIZONTAL](state, data) {
    state.isInterlocutorHorizontal = data;
  },
  [SET_IS_HORIZONTAL_OPENED_FILES](state, data) {
    state.isHorizontalOpenedFiles = data;
  },
  [SET_IS_IPHONE_LOADER](state, data) {
    state.isIphoneLoader = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};